import React, { useEffect, useState, useRef, Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import CustomFieldItem from './customFieldItem';
import ListFieldOption from './listField/options';

import styles from './fields.module.scss';
import { fetchingCustomField, fetchCustomFields, deleteCustomField, createCustomField, updateCustomField, reorderCustomFields, invalidateCustomFields } from 'actions/fields/fields';

import { guid, getBaseUrl } from 'services/util';

import _ from "lodash";
import cx from "classnames";

import {
  Dropdown,
  Button,
  Form
} from "react-bootstrap";

import { Sortable } from "@shopify/draggable";

export default function CustomFieldsView(props) {
  const dispatch = useDispatch()

  const loading = useSelector((state) => _.get(state, "fields.loading") || false);
  const updating = useSelector((state) => _.get(state, "fields.updating") || false);

  const workspace = useSelector((state) => _.get(state, "workspaces.workspace.item") || null);
  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item") || null);
  const storyboardType = _.get(storyboard, 'type', '');

  const customFields = useSelector((state) => _.get(state, "fields.items") || []);
  const currentField = useSelector((state) => _.get(state, "fields.currentField") || null);

  const [canCreate, setCanCreate] = useState(false);

  useEffect(() => {
    dispatch(fetchCustomFields(storyboard.id));

    return (() => {
      dispatch(invalidateCustomFields());
    })
  }, []);

  useEffect(() => {
    if (customFields && customFields.length > 0) {
      dispatch(fetchingCustomField(storyboard.id, customFields[0].id));
      setCanCreate(true);
    } else {
      setCanCreate(false);
    }
  }, [customFields]);

  return (
    <div className={styles.customFieldsContainer}>
      <div className={styles.header}>Custom Fields</div>
      <div className={styles.description}>Craft your Custom-made-fields here.</div>
      {loading &&
        <LoadingMessage />
      }

      {!loading && !updating && !canCreate &&
        <CustomFieldsEmptyMessage handleCreate={() => setCanCreate(true)} />
      }

      {!loading && canCreate &&
        <CustomFieldsListView loading={loading} updating={updating} workspace={workspace} storyboard={storyboard} customFields={customFields} currentField={currentField} />
      }
    </div>
  )
}

function CustomFieldsListView({ loading, updating, workspace, storyboard, customFields, currentField }) {

  const dispatch = useDispatch();
  const history = useHistory();
  const sortable = useRef(null);
  const container = React.createRef(null);
  const optionContainer = React.createRef(null);

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const [state, setState] = useState({
    selection: {
      multiselect: false,
      options: []
    },
    creating: false
  });

  /* TODO Fix: 

  Should be enabled after fixing the field reorder defect

  // useEffect(() => {
  //     if (!container.current) {
  //         return
  //     }
      
  //     sortable.current = new Sortable(container.current, {
  //         draggable: `.${styles.customField}`,
  //         handle: `.${styles.customField}`,
  //         delay: 300,
  //         mirror: {
  //           appendTo: `.${styles.fieldsList}`,
  //           constrainDimensions: true
  //         }
  //     });
  // }, []);


  // useEffect(() => {

  //     // if(customFields && customFields.length > 0) {
  //     //     dispatch(fetchingCustomField(storyboard.id, customFields[0].id));
  //     // }
  
  //     if (!container.current || !sortable.current) {
  //       return;
  //     }
  
  //     sortable.current.on("sortable:stop", handleFieldReorder);
  
  //     return () => {
  //       sortable.current.off('sortable:stop', handleFieldReorder);
  //     }

  // }, [customFields]);

  */

  useEffect(() => {
    if (currentField) {
      history.push(`${baseUrl}/storyboards/${storyboard.id}/custom-fields/${currentField.id}`);
    } else {
      history.push(`${baseUrl}/storyboards/${storyboard.id}/custom-fields/new?type=list_field`);
    }

    setState({
      ...state,
      selection: currentField
    });

  }, [currentField]);

  const handleFieldReorder = (e) => {
    const oldIndex = e.data.oldIndex;
    const newIndex = e.data.newIndex;

    var fields = customFields;

    var customField = fields[oldIndex];

    fields.splice(oldIndex, 1);
    fields.splice(newIndex, 0, customField);

    let customFieldIds = fields.map((customField) => customField.id);
    dispatch(reorderCustomFields(storyboard.id, customFieldIds));
  }

  const handleClick = (customField) => {
    if (customField) {
      history.push(`${baseUrl}/storyboards/${storyboard.id}/custom-fields/${customField}`);
      dispatch(fetchingCustomField(storyboard.id, customField));
    } else if (state.creating && !customField) {
      history.push(`${baseUrl}/storyboards/${storyboard.id}/custom-fields/new?type=list_field`);

      let item = {
        name: "Untitled",
        helpText: "",
        multiselect: false,
        options: [],
        type: "list_field"
      }

      setState((state) => {
        return {
          ...state,
          selection: item
        }
      })
    }
  }

  const handleNameChange = (e) => {
    const value = e.target.value;

    let index = customFields.findIndex(customField => {
      return customField.id == state.selection.id;
    });

    let updatedField = {
      ...state.selection,
      name: value
    };

    customFields[index] = updatedField;

    setState((state) => {
      return {
        ...state,
        selection: updatedField
      }
    });
  }

  const handleHelpTextChange = (e) => {
    const value = e.target.value;

    setState((state) => {
      return {
        ...state,
        selection: {
          ...state.selection,
          helpText: value
        }
      }
    });
  }

  const handleToggle = (event) => {
    setState((state) => {
      return {
        ...state,
        selection: {
          ...state.selection,
          multiselect: !state.selection.multiselect
        }
      }
    })
  }

  const handleSave = () => {

    if (state.creating) {
      dispatch(createCustomField(storyboard.id, state.selection));
      setState((state) => {
        customFields.splice(0, 1);
        return {
          ...state,
          creating: false
        }
      });

    } else {
      var selection = Object.assign({}, currentField, state.selection);
      dispatch(updateCustomField(storyboard.id, currentField.id, selection));
    }
  }

  const handleResetClick = () => {


    if (state.selection.id) {
      let index = customFields.findIndex(item => {
        return item.id == currentField.id
      });

      let updatedField = customFields[index];

      setState((state) => {
        return {
          ...state,
          selection: {
            ...currentField,
            options: [
              ...currentField.options
            ]
          }
        }
      })
    } else {
      let item = {
        name: "Untitled",
        helpText: "",
        multiselect: false,
        options: [],
        type: "list_field"
      }

      setState((state) => {
        return {
          ...state,
          selection: item
        }
      })
    }

  }

  const handleDelete = (customField) => {
    dispatch(deleteCustomField(storyboard.id, customField));
  }

  const addValue = () => {
    let selectedOptions = state.selection.options;
    let item = {
      id: guid(),
      value: "Untitled"
    }

    setState((state) => {
      return {
        ...state,
        selection: {
          ...state.selection,
          options: [...selectedOptions, item]
        }
      }
    });
  }

  const handleDeleteClick = (option) => {
    let options = state.selection.options.filter((item) => item.id !== option.id);

    setState((state) => {
      return {
        ...state,
        selection: {
          ...state.selection,
          options: options
        }
      }
    })
  }

  const handleCreateField = () => {

    if (state.creating) {
      return;
    }

    let item = {
      name: "Untitled",
      helpText: "",
      multiselect: false,
      options: [],
      type: "list_field"
    }

    customFields.splice(0, 0, item);

    setState((state) => {
      return {
        ...state,
        creating: true,
        selection: item
      }
    });
    history.push(`${baseUrl}/storyboards/${storyboard.id}/custom-fields/new?type=list_field`);
  }

  const handleInputChange = (e, option) => {
    let index = state.selection.options.findIndex((item) => {
      return item.id === option.id;
    });

    let options = state.selection.options;

    let updatedOption = {
      id: option.id,
      value: e.target.value
    };

    options[index] = updatedOption;
    setState((state) => {
      return {
        ...state,
        selection: {
          ...state.selection,
          options: [
            ...options
          ]
        }
      }
    })
  }

  useEffect(() => {

    if (_.isEmpty(customFields)) {
      handleCreateField();
    }

    if (!optionContainer.current) {
      return
    }

    sortable.current = new Sortable(optionContainer.current, {
      draggable: `.cs-draggable-item`,
      handle: `.cs-drag`,
      delay: 300,
      mirror: {
        appendTo: `.${styles.fieldOptions}`,
        constrainDimensions: true
      }
    });
  }, []);


  useEffect(() => {

    if (!optionContainer.current || !sortable.current) {
      return;
    }

    sortable.current.on("sortable:stop", handleOptionReorder);

    return () => {
      sortable.current.off('sortable:stop', handleOptionReorder);
    }

  }, [state.selection]);

  const handleOptionReorder = (e) => {
    const oldIndex = e.data.oldIndex;
    const newIndex = e.data.newIndex;

    var option = state.selection.options[oldIndex];

    state.selection.options.splice(oldIndex, 1);
    state.selection.options.splice(newIndex, 0, option);
  }

  return (
    <Fragment>
      <>
        <div className={styles.listContainer}>
          <div className={styles.listView}>
            <div className={styles.fieldsHeader}>
              <header>Fields</header>
              <Button variant='primary' className={styles.createFieldButton} onClick={handleCreateField}>
                <i className={'cleverstory-plus'} />
                New Custom Field
              </Button>
            </div>
            <div className={styles.dividend}></div>
            <div className={styles.fieldsList} ref={container}>
              {customFields &&
                customFields.map(customField => {
                  return <CustomFieldItem customField={customField} onDelete={() => handleDelete(customField.id)} onClick={() => handleClick(customField.id)} fieldSelected={customField && state.selection && customField.id === state.selection.id} />
                })
              }
            </div>
          </div>
          <div className={styles.manageView}>
            <div className={styles.fieldsHeader}>
              <header>Configuration</header>
              <span className={styles.fieldType}>Type: <i className='cleverstory-list-field' /> List</span>
            </div>
            <div className={styles.dividend}></div>
            <div className={styles.wrapperContainer}>
              <div className={styles.formContainer}>
                <Form className={styles.form} onSubmit={(e) => e.preventDefault()}>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={state.selection ? state.selection.name : null}
                      onChange={handleNameChange}
                    />
                  </Form.Group>
                  <Form.Group controlId="pageDescription" className={styles.textArea}>
                    <Form.Label className={styles.label}>Help Text</Form.Label>
                    <Form.Control
                      as="textarea"
                      className={styles.control}
                      type="text"
                      name="description"
                      value={state.selection ? state.selection.helpText : null}
                      placeholder="Enter help text"
                      onChange={handleHelpTextChange}
                      rows={4}
                    />
                  </Form.Group>
                  <div className={styles.multiSelect}>
                    <Form.Label className={styles.label}>Allow Multi Select Text</Form.Label>
                    <Form.Check
                      type="switch"
                      checked={state.selection ? state.selection.multiselect : null}
                      className={styles.toggleSwitch}
                      onChange={handleToggle}
                    />
                  </div>
                </Form>
              </div>
              <div className={styles.optionsContainer} >
                <div className={styles.optionsHeader}>
                  <header>List Values</header>
                  <Button variant='primary' className={styles.createFieldButton} onClick={addValue}>
                    <i className={'cleverstory-plus'} />
                    Add Value
                  </Button>
                </div>
                <div className={styles.fieldOptions} ref={optionContainer}>
                  <ListFieldOption selection={state.selection} handleDelete={(option) => handleDeleteClick(option)} handleChange={(e, option) => handleInputChange(e, option)} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <Button variant="secondary"
            disabled={!loading && customFields.length == 0 || updating}
            className={styles.resetButton}
            type="reset"
            onClick={handleResetClick}
          >
            Reset
          </Button>
          <Button variant="primary"
            disabled={!loading && _.isEmpty(customFields) || updating || state.selection && state.selection.name == "" || state.selection && state.selection.options.length == 0}
            className={styles.saveButton}
            type="submit"
            onClick={handleSave}
          >
            {updating ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </>
    </Fragment>
  )
}

function CreateCustomField({ onCreate }) {
  const [show, setShow] = useState(false);

  const handleToggle = () => {
    setShow(!show);
  }

  return (
    <Dropdown
      onMouseLeave={() => setShow(false)}
      onMouseOver={() => setShow(true)}
      className={styles.createFieldButton}
      open={show}
      onToggle={handleToggle}>

      <Dropdown.Toggle variant="success" id="dropdown-basic">
        <i className={cx(styles.icon, 'cleverstory-plus')} />
        New Custom Field
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={onCreate}>
          <div><i className="cleverstory-list-field"></i>
            List
          </div>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

function CustomFieldsEmptyMessage({ handleCreate }) {

  return (
    <div className={styles.emptyMessageContainer}>
      <div className={styles.emptyMessage}>
        <div className={styles.heading}>Weather forecast</div>
        <div className={styles.description}>Clear Skies and Empty <br /> Fields</div>
        <CreateCustomField onCreate={handleCreate} />
      </div>
      <div className={styles.buttonContainer}>
        <Button variant="secondary"
          className={styles.resetButton}
          type="reset"
        >
          Reset
        </Button>
        <Button variant="primary"
          className={styles.saveButton}
          type="submit"
        >
          Save Changes
        </Button>
      </div>
    </div>
  )
}

function LoadingMessage() {
  return (
    <div className={styles.loaderContainer}>
      <label>Just a moon-ute... Scanning for fields...</label>
    </div>
  )
}